module.exports = __webpack_public_path__ + "media/assets/images/blog/customer_service_operator-7660ffc37011456ddcd6aba05e840f40.jpeg";